<app-fn-ui-navigation-tree class="custom-account-groups-navigation"
                           [treeConfig]="customAccountGroupsService.treeConfig"
                           [treeModel]="customAccountGroupsService.tree.nodes"
                           [selectedNode]="customAccountGroupsService.activeNode">
</app-fn-ui-navigation-tree>
